import { Event, Player, Team } from 'src/api';
import { MainMenuOption } from 'src/service/MainMenu';
import { AbstractUserRole } from 'src/service/UserPermission/AbstractUserRole';

export class MedicalReviewerRole extends AbstractUserRole {
  canView(option: MainMenuOption): boolean {
    const allowed = [
      MainMenuOption.team,
      MainMenuOption.player,
      MainMenuOption.event,
      MainMenuOption.assessment,
      MainMenuOption.home,
    ];
    return allowed.includes(option);
  }

  // teams
  canViewTeam(team: Team): boolean {
    return this.list.has(team.id ?? 0);
  }

  // players
  canViewPlayer(player: Player): boolean {
    return (
      player.playerTeams?.some((playerTeams) =>
        this.list.has(playerTeams.team?.id ?? 0),
      ) ?? false
    );
  }

  canReviewEvent(event: Event): boolean {
    return (
      event.player?.playerTeams?.some((playerTeams) =>
        this.list.has(playerTeams.team?.id ?? 0),
      ) ?? false
    );
  }
}
